import { createTrack } from './track'
import { TRACK_CHECKPOINT_COUNT, TRACK_CONTROL_POINTS, TRACK_SAMPLE_COUNT, TRACK_WIDTH } from './track-data'
import type { Track } from './types'

export function createCanonicalTrack(): Track {
  return createTrack(TRACK_CONTROL_POINTS, TRACK_SAMPLE_COUNT, TRACK_CHECKPOINT_COUNT, TRACK_WIDTH)
}
